var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"router"},[_c('div',{staticClass:"bgimg"}),_c('router-view',{staticStyle:{"position":"relative","z-index":"5"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }